import VariableIcon from '@atlaskit/icon-lab/core/variable';
import * as React from 'react';

export function SvgVariables() {
  return <VariableIcon label="" testId="ads-refreshed-icon" />;
}
